import axios from "axios";
import {materialCloudServicesPath, ordersServicesPath} from "../../Constants";
import BalanceSheet from "../../pages/organization/prodaction/issuance/BalanceSheet";

const restUrl = ordersServicesPath + '/organizations/files/download'
const restUrlAdmin = materialCloudServicesPath + '/admin/files/download'

export default class FileDownloadController {
    static async exportGroupFile() {
        return axios.get(`${restUrl}/group-materials`, {
            responseType: 'blob'
        });
    }

    static async exportMaterialsFile() {
        return axios.get(`${restUrl}/materials`, {
            responseType: 'blob'
        });
    }

    static async exportSupplierMaterialsFile() {
        return axios.get(`${restUrl}/supplier-materials`, {
            responseType: 'blob'
        });
    }

    static async exportGroupFileAdmin() {
        return axios.get(`${restUrlAdmin}/material-group`, {
            responseType: 'blob'
        });
    }

    static async exportMaterialsFileAdmin() {
        return axios.get(`${restUrlAdmin}/materials`, {
            responseType: 'blob'
        });
    }

    static async exportSupplierMaterialsFileAdmin() {
        return axios.get(`${restUrlAdmin}/supplier-materials`, {
            responseType: 'blob'
        });
    }

    static async exportMaterialsInWork(localDateTime) {
        return axios.get(`${restUrl}/materials-in-work?localDateTime=${localDateTime}`, {
            responseType: 'blob'
        });
    }

    static async exportMaterialsInStock(localDateTime) {
        return axios.get(`${restUrl}/materials-in-stock?localDateTime=${localDateTime}`, {
            responseType: 'blob'
        });
    }

    static async exportMaterialsBalanceSheet(start, end, skipZero) {
        return axios.get(`${restUrl}/balance-sheet?start=${start}&end=${end}&skipZero=${skipZero}`, {
            responseType: 'blob'
        });
    }
}